import { SubscriptionCheckoutOptionKind } from '@src/types'

// Used in cases when we want to automatically select a sensor for the user
// instead of showing them sensor selection.
export const useAutomaticCheckoutOptionKinds = () => {
  return [SubscriptionCheckoutOptionKind.Stelo]
}
